//@ts-ignore
import React, { useState, useEffect, Suspense, lazy } from "react";
import { ComponentProps } from "../../../types";
import { Tree } from "../../../lib/useTrees";
import * as styles from "./ArboretumMap.module.css";

import compass from "./assets/compass-nocircle.png";
import shrub from "./assets/shrub.png";
import deciduous from "./assets/deciduous.png";
import coniferous from "./assets/coniferous.png";
import shrubChampion from "./assets/shrub-champion.png";
import deciduousChampion from "./assets/deciduous-champion.png";
import coniferousChampion from "./assets/coniferous-champion.png";

import { SectionWrapper } from "../../containers/SectionWrapper";

const ThreeCanvas = lazy(() => import("./ThreeCanvas"));

interface Props extends ComponentProps {
  trees: Tree[];
  height?: string;
  title?: string;
}

export const ArboretumMap: React.FC<Props> = ({
  trees,
  height = "500px",
  title,
  ...props
}) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <SectionWrapper {...props}>
      <div className={styles.ArboretumMap}>
        {title ? <h2>{title}</h2> : null}
        {!isMounted ? null : (
          <Suspense fallback={null}>
            <ThreeCanvas trees={trees} height={height} />
          </Suspense>
        )}
        <div className={styles.key}>
          <div className={styles.label}>Key</div>
          <div className={styles.keyItem}>
            <img src={deciduous} alt={"Green Deciduous Tree"} />
            Deciduous Trees
          </div>
          <div className={styles.keyItem}>
            <img src={deciduousChampion} alt={"Gold Deciduous Tree"} />
            Deciduous Champion Trees
          </div>
          <div className={styles.keyItem}>
            <img src={coniferous} alt={"Green Coniferous Tree"} />
            Coniferous Trees
          </div>
          <div className={styles.keyItem}>
            <img src={coniferousChampion} alt={"Gold Coniferous Tree"} />
            Coniferous Champion Trees
          </div>
          <div className={styles.keyItem}>
            <img src={shrub} alt={"Green Shrub"} />
            Shrubs
          </div>
          <div className={styles.keyItem}>
            <img src={shrubChampion} alt={"Gold Shrubs"} />
            Champion Shrubs
          </div>
          <div className={[styles.keyItem, styles.compass].join(" ")}>
            <img src={compass} alt={"Compass indicating North is up"} />
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};
